import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, type = 'website' }) => {
  const baseUrl = 'https://izomag.ro';
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;
  const fullTitle = title
    ? `${title} | IzoMAG Hidroizolatii Iasi`
    : 'IzoMAG Hidroizolatii Iasi | Membrane Bituminoase & EPDM Moldova';
  const metaDesc = description || 'IzoMAG - Hidroizolatii profesionale in Iasi si Moldova. Membrane bituminoase Bauder, General Membrane, Sika. Reparatii acoperis, infiltratii, injectari rasina.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <link rel="canonical" href={fullCanonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content={type} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
    </Helmet>
  );
};

export default SEO;
